import { IResaleCoBroke, IResaleExternalCoBroke } from '.';

export interface IResaleRelatedAgent {
  mains: IResaleCoBroke[];
  internals: IResaleCoBroke[];
  externals: IResaleExternalCoBroke[];
}
